import script from "./StockComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./StockComponent.vue?vue&type=script&lang=ts&setup=true"

import "./StockComponent.vue?vue&type=style&index=0&id=1f8806d8&scoped=true&lang=css"

import exportComponent from "/home/node/skat32-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1f8806d8"]])

export default __exports__